import { render, staticRenderFns } from "./modal-backup-codes.vue?vue&type=template&id=177bb54c&"
import script from "./modal-backup-codes.vue?vue&type=script&lang=js&"
export * from "./modal-backup-codes.vue?vue&type=script&lang=js&"
import style0 from "./modal-backup-codes.vue?vue&type=style&index=0&id=177bb54c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports